import dayjs from 'dayjs';

/**
 * Диапазон запроса под сетку месяца: 6 недель от понедельника и по суткам с
 * каждой стороны. Запас нужен потому, что день здесь считается по часам
 * браузера, а сроки — по часам организации: без него пункт первого дня сетки
 * не попадал бы в ответ у человека западнее организации.
 */
export function calendarRange(monthStart: string | dayjs.Dayjs): { from: string; to: string } {
  const cursor = dayjs(monthStart).startOf('month');
  const gridStart = cursor.subtract((cursor.day() + 6) % 7, 'day');
  return {
    from: gridStart.subtract(1, 'day').toISOString(),
    to: gridStart.add(43, 'day').toISOString(),
  };
}
